import { axiosInstance } from '../App';

const BASE = '/api/secured/professionalpayment';

/** PDF de la orden de pago, venga de una rendición o de una liquidación. */
export async function downloadPaymentOrderReceipt(paymentOrderFormId: number, formNumber: number): Promise<void> {
    const response = await axiosInstance.get(`${BASE}/generatePaymentOrderReceipt`, {
        params: { paymentOrderFormId },
        responseType: 'blob',
    });
    savePdf(response.data, `orden-de-pago-${formNumber}.pdf`);
}

/**
 * PDF del resumen de una rendición o liquidación, por su comprobante interno: las prestaciones y, de los honorarios
 * al saldo, todo lo que se descontó y se pagó. Lo tiene aunque se haya saldado sin orden de pago.
 */
export async function downloadReceiptSummary(receiptFormId: number, fileName: string): Promise<void> {
    const response = await axiosInstance.get(`${BASE}/generateReceiptSummary`, {
        params: { receiptFormId },
        responseType: 'blob',
    });
    savePdf(response.data, fileName);
}

function savePdf(data: BlobPart, fileName: string) {
    const url = URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(url);
}
